import qs from 'qs'
import request from '@/utils/request'

// 管理员账号相关接口（/qw-admin，Admin-Token 鉴权由 request 拦截器统一注入）

// 管理员登录：返回 { adminToken, expiresIn, user }
export function adminLogin (data) {
    return request({
        url: '/qw-admin/login',
        method: 'post',
        data: qs.stringify(data)
    })
}

// 管理员登出（吊销当前令牌）
export function adminLogout () {
    return request({
        url: '/qw-admin/logout',
        method: 'post'
    })
}

// 当前登录管理员信息（token 失效时后端返回 401 业务码）
export function adminCurrent () {
    return request({
        url: '/qw-admin/current',
        method: 'post'
    })
}

// 修改自己的密码：oldPassword/newPassword，新密码至少 6 位
export function adminChangePassword (data) {
    return request({
        url: '/qw-admin/changePassword',
        method: 'post',
        data: qs.stringify(data)
    })
}
